import tokenData from '../../design-tokens/base-tokens.json';
export const MuiAppBar = {
    variants: [
        {
            props: { variant: 'alt' },
            style: {
                background: tokenData.tokens.palette.background.white,
                color: tokenData.tokens.palette.background.blue500,
                fontWeight: 600
            }
        }
    ],
    styleOverrides: {
        root: {
            background: tokenData.tokens.palette.blue.blue500,
            color: tokenData.tokens.palette.background.white,
            fontWeight: 600,
            '& .MuiButtonBase-root': {
                '&.MuiIconButton-root': {
                    color: tokenData.tokens.palette.background.white,
                    '&:hover': {
                        color: tokenData.tokens.palette.background.white
                    }
                }
            },
            '& .MuiToolbar-root .Mui-focusVisible': {
                outlineColor: tokenData.tokens.palette.background.white
            }
        },
        colorPrimary: {
            background: tokenData.tokens.palette.blue.blue700
        }
    }
};
export default MuiAppBar;
